import { useEffect } from "react";

export const usePageMeta = (title, description) => {
    useEffect(() => {
        document.title = title;
        if (description) {
            let desc = document.querySelector('meta[name="description"]');
            if (desc) desc.setAttribute("content", description);
            let og = document.querySelector('meta[property="og:description"]');
            if (og) og.setAttribute("content", description);
        }
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }
        canonical.href = window.location.origin + window.location.pathname;
    }, [title, description]);
};
